// utils/pollyVisemeTable.ts

// Polly viseme type
type PollyViseme =
  | "p"
  | "t"
  | "S"
  | "T"
  | "f"
  | "k"
  | "i"
  | "l"
  | "r"
  | "s"
  | "u"
  | "@"
  | "a"
  | "e"
  | "E"
  | "o"
  | "O"
  | "sil"

// Rive input names type
export type RiveInputName =
  | "B M P"
  | "O"
  | "F V"
  | "t"
  | "T"
  | "U"
  | "Q"
  | "W"
  | "E"
  | "R"
  | "S"
  | "s"
  | "L"
  | "N"
  | "K"
  | "J I"
  | "A E"
  | "CLOSE"

// viseme mapping
export const visemeMapping: Record<PollyViseme, RiveInputName> = {
  p: "B M P",
  t: "t",
  S: "N",
  T: "T",
  f: "F V",
  i: "K",
  "@": "J I",
  l: "L",
  r: "R",
  s: "s",
  u: "Q",
  E: "W",
  a: "A E",
  e: "E",
  o: "O",
  O: "S",
  k: "t",
  sil: "CLOSE",
}

// input names array
export const INPUT_NAMES: readonly RiveInputName[] = [
  "B M P",
  "O",
  "F V",
  "t",
  "T",
  "U",
  "Q",
  "W",
  "E",
  "R",
  "S",
  "s",
  "L",
  "N",
  "K",
  "J I",
  "A E",
  "CLOSE",
] as const

// Polly visemes
export const POLLY_VISEMES: readonly PollyViseme[] = [
  "p",
  "t",
  "S",
  "T",
  "f",
  "k",
  "i",
  "l",
  "r",
  "s",
  "u",
  "@",
  "a",
  "e",
  "E",
  "o",
  "O",
  "sil",
] as const

// get Rive input from Polly viseme
export function getRiveInput(pollyViseme: string): RiveInputName {
  // Type check
  if (pollyViseme in visemeMapping) {
    return visemeMapping[pollyViseme as PollyViseme]
  }

  console.warn(`Unknown Polly viseme: ${pollyViseme}, defaulting to CLOSE`)
  return "CLOSE"
}

// check if a string is a valid Polly viseme
export function isValidPollyViseme(viseme: string): viseme is PollyViseme {
  return viseme in visemeMapping
}
